export function FormattedTipDirective() {
    'ngInject';

    return {
        restrict: 'A',
        require: 'ngModel',
        link: ($scope, $element, $attrs, $model) => {
            // Have to unshift instead of push, otherwise ngModel complains like
            // "[ngModel:numfmt] Expected `0.00` to be a number" because we have type[number].
            $model.$formatters.unshift(_formatNumber);

            $element.bind('blur', () => {
                if ($model.$valid) {
                    $model.$setViewValue(_formatNumber($model.$modelValue));
                    $model.$render();
                }
            });
        }
    };

    function _formatNumber(modelValue) {
        // Can't use $filter('number') since the type[number] input doesn't
        // accept commas (in case of a very generous tip).
        const num = parseFloat(modelValue);
        return Number.isFinite(num) ? num.toFixed(2) : '';
    }
}
